import { SiAppstore, SiGoogleplay } from "react-icons/si";

export const APP_PLAY_STORE_URL =
    "https://play.google.com/store/apps/details?id=com.arhax.veshjeperty";
export const APP_APPLE_STORE_URL =
    "https://apps.apple.com/us/app/veshje-per-ty/id6702026150";

const storeBtnClass =
    "inline-flex items-center justify-center gap-2 min-h-[2.75rem] px-4 py-2 rounded-xl font-medium text-sm transition border border-gray-200 bg-white text-gray-800 hover:border-[#704e37]/50 hover:bg-[#704e37]/5 focus:outline-none focus:ring-2 focus:ring-[#704e37]/30";

type AppStoreLinksProps = {
    className?: string;
    /** Hide the leading label */
    hideLabel?: boolean;
};

/**
 * Links to the native apps on Google Play and the App Store.
 */
function AppStoreLinks({ className = "", hideLabel = false }: AppStoreLinksProps) {
    return (
        <div className={className}>
            {!hideLabel && (
                <p className="text-sm font-medium text-gray-800 mb-2">Aplikacioni në telefon</p>
            )}
            <div className="flex flex-col sm:flex-row flex-wrap gap-2">
                <a
                    href={APP_PLAY_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={storeBtnClass}
                >
                    <SiGoogleplay className="text-xl text-[#01875f]" aria-hidden />
                    Google Play
                </a>
                <a
                    href={APP_APPLE_STORE_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={storeBtnClass}
                >
                    <SiAppstore className="text-xl text-gray-700" aria-hidden />
                    App Store
                </a>
            </div>
        </div>
    );
}

export default AppStoreLinks;
